<template>
    <div class="sign-in--container">
        <div class="sign-in--card">
            <div class="sign-in--card--background">
                <img src="/img/logo-color.svg" alt="">
                <h2>Plataforma de evaluación</h2>
                
                <template v-if="step == 'init'">
                    <Form style="width: 100%" ref="forgotPassword" :model="forg" :rules="ruleInline">
                        <FormItem prop="password">
                            <Input size="large" type="password" v-model="forg.password" placeholder="Nueva contraseña"/>
                        </FormItem>
                        <FormItem style="margin-bottom: 0 !important">
                            <Button :loading="loading" long size="large" type="primary" @click="handleSubmit">Actualizar</Button>
                            <Button @click="$router.push('/')" style="margin-top: 25px" size="small" type="text">O puedes iniciar sesión</Button>
                        </FormItem>
                    </Form>
                </template>

                <template v-if="step == 'success'">
                    <div style="height: 105px; display: flex; align-items: center; justify-content: center; text-align: center; flex-direction: column;">
                        <h3>Tu información fue actualizada correctamente.</h3>
                        <p>Ahora puedes iniciar sesión en la plataforma.</p>
                        <br>
                        <Button long size="large" type="primary" @click="$router.push('/')">Inicio de sesión</Button>
                    </div>
                </template>

                <template v-if="step == 'error'">
                    <div style="height: 105px; display: flex; align-items: center; justify-content: center; text-align: center; flex-direction: column;">
                        <h3>El proceso no se pudo completar</h3>
                        <p>Recuerda que el enlace que te proporcionamos vía correo electrónico tiene una vigencia de 15 minutos.</p>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                step: 'init',
                forg: {
                    password: '',
                },
                loading: false,
                ruleInline: {
                    password: [
                        { required: true, message: 'Correo electrónico es requerido', trigger: 'blur' }
                    ],
                }
            }
        },
        methods: {
            handleSubmit(){
                this.$refs.forgotPassword.validate(valid => {
                    console.log(valid)
                    if(valid){
                        this.loading = true
                        window.axios.post(this.$root.API_URL + '/auth/forgot-password/secure', { token: this.$route.params.token,  ...this.forg })
                        .then(response => {

                            if(response.data.success){
                                this.step = 'success'
                            }
                            else {
                                this.$Message.error(response.data.message);
                                this.loading = false
                                this.step = 'error'
                            }

                        })
                        .catch(() => {
                            this.$Message.error('Whoops, algo salió mal');
                            this.loading = false
                            this.step = 'error'
                        })

                    }
                })
            }
        }
    }
</script>